export default __webpack_public_path__ + "static/media/small-utensils.6aca331c.svg";